
<div class="thread-container">
  <h4 class="thread-title">Conversation</h4>
  <ul class="thread-list">
    @for (email of emails; track email.id; let last = $last) {
    <li class="thread-item" [class.current]="email.messageId === currentEmailId" (click)="click(email)">
      <div class="thread-marker">
        <span class="marker-dot"></span>
        @if (!last) {
        <span class="marker-line"></span>
        }
      </div>
      <div class="thread-content">
        <span class="thread-sender">{{ extractName(email.metadata_message_from) }}</span>
        <span class="thread-date">{{ formatDate(email.metadata_creation_date) }}</span>
        <span class="thread-subject">{{ email.metadata_subject ?? email.normalizedSubject }}</span>
      </div>
    </li>
    }
  </ul>
</div>
